export default __webpack_public_path__ + "static/media/Visibilidade ON.57557e4c.svg";